import React from 'react';
import { useState, useEffect } from 'react';
import '../Policy.css';
import pdficon from '../../../assets/Union.png';
import { fetchPolicyPdfs } from '../../../utils/fetchFromApi';

interface Policy {
	title?: string;
	document?: string;
}
const PdfTile = () => {
	const [policyCard, setPolicyCard] = useState([]);
	const [selectedPdf, setSelectedPdf] = useState<string | null>(null);

	useEffect(() => {
		fetchPolicyPdfs()
			.then((data) => {
				setPolicyCard(data.map((item: any) => item.acf));
				console.log('clicked', data);
			})
			.catch((error) => console.log(error));
	}, []);

    const openPdf = (pdfUrl: string) => {
        setSelectedPdf(pdfUrl);
    };
 
    const closePdf = () => {
        setSelectedPdf(null);
    };
 
	return (
<>
		<div className="flex flex-wrap items-start justify-center gap-4 py-[80px] lg:py-[120px]">
		{policyCard.map((item: any, index) => (
                    item["show_to_downloads"]=="no"?<div
                        key={index}
                        className="flex flex-col items-center transition duration-150 hover:scale-105"
                    >
                        <div
                            className="pdf-tile cursor-pointer"
                            onClick={() => openPdf(item['document'])}
                        >
                            <img src={pdficon} alt="PDF" />
                        </div>
                        <div className="w-3/5 text-center">
                            <div>{item['document-name']}</div>
                        </div>
                    </div>:<></>
                   
                ))}			
		</div>
		{/* Fullscreen PDF Viewer */}
            {selectedPdf && (
                <div className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-90">
                    <div className="relative h-[90%] w-[90%] overflow-hidden rounded-lg bg-white shadow-lg">
                        <iframe
                            src={`${selectedPdf}#toolbar=0&navpanes=0&scrollbar=0`}
                            title="PDF Viewer"
                            className="h-full w-full border-none"
                        />
 
                        <button
                            onClick={closePdf}
                            className="absolute right-2 top-2 z-[100] flex h-10 w-10 items-center justify-center rounded-full bg-gray-700 text-3xl font-bold text-white"
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}
</>
	);
};

export default PdfTile;
